import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../components/Card";
import { postApiCall } from "../../../service/postApiCall";
import { API_MANAGE_LOCATIONS_CREATE } from "../../../service/url";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

const CreateLocation = () => {
    const [locationName, setLocationName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [errors, setErrors] = useState({})
    const navigate = useNavigate();

    const handleCreateLocation = async (e) => {
        e.preventDefault();

        if (!locationName.trim()) {
            setErrors({
                NameError: "Dialer Location name required"
            })
            return;
        }

        setIsLoading(true);
        setButtonDisabled(true);

        const payload = {
            location_name: locationName.trim(),
        };

        try {
            const response = await postApiCall(API_MANAGE_LOCATIONS_CREATE, payload);
            console.log(response);
            if (response) {
                toast.success("Dialer Location created successfully");
                setTimeout(() => {
                    navigate("/location-list");
                }, 2000);
            }
        } catch (error) {

            console.log(error);
            toast.error(error || "Something went wrong");
        } finally {
            setIsLoading(false);
            setButtonDisabled(false);
        }
    };

    return (
        <div>
            <Row>
                <Col xl="12" lg="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Create Dialer Location</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleCreateLocation}>
                                <Form.Group className="mb-3 col-md-6">
                                    <Form.Label htmlFor="locationName">Dialer Location Name: <span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="locationName"
                                        placeholder="Enter dialer location name"
                                        value={locationName}
                                        isInvalid={!!errors.NameError}
                                        onChange={(e) => {
                                        const val = e.target.value;
                                        if (/^[A-Za-z\s]*$/.test(val)) {
                                        setLocationName(val);
                                        if (errors.NameError) {
                                        setErrors({});
                                          }
                                        }
                                     }}

                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.NameError}
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={buttonDisabled}
                                >
                                    {isLoading ? "Creating..." : "Create"}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default CreateLocation;
